export const VARIANTS = {
    BORDERED: 'bordered',
    DEFAULT: 'default',
    DIVIDER: 'divider',
};
export var CONTENT_TYPES;
(function (CONTENT_TYPES) {
    CONTENT_TYPES["CUSTOM_PAGE"] = "custom_page";
    CONTENT_TYPES["EVENT"] = "event";
    CONTENT_TYPES["FILE"] = "file";
    CONTENT_TYPES["FILEFOLDER"] = "filefolder";
    CONTENT_TYPES["FOLDER"] = "folder";
    CONTENT_TYPES["FORUM"] = "forum_discussion";
    CONTENT_TYPES["GROUP"] = "group";
    CONTENT_TYPES["NEWS"] = "news";
    CONTENT_TYPES["OPPORTUNITY"] = "opportunity";
    CONTENT_TYPES["ORGANIZATION"] = "organization";
    CONTENT_TYPES["POST"] = "post";
    CONTENT_TYPES["PROJECT"] = "project";
    CONTENT_TYPES["TRENDING"] = "trending";
    CONTENT_TYPES["USER"] = "user";
})(CONTENT_TYPES || (CONTENT_TYPES = {}));
export const CONTENT_LIST_SIZES = {
    HIGHLIGHT: 'highlight',
    LARGE: 'large',
    SMALL: 'small',
};
export const COMMON_DISPLAY_FIELDS_KEYS = ['contentType'];
//# sourceMappingURL=constants.js.map